import TextArea from "./TextArea"
import "./textArea.scss"
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

export default TextArea
